import React, { useEffect } from "react";
import VerticalBarChart from "../../Components/Dashboard/Chart/VerticalBarChart";
import ConsulteCard from "../../Components/Dashboard/ConsulteCard";
import { ReactComponent as ArticleIcon } from "../../images/Dashboard/Article.svg";
import { ReactComponent as FileIcon } from "../../images/Dashboard/FileIcon.svg";
import { ReactComponent as ProductIcon } from "../../images/Dashboard/ProductIcon.svg";
import { ReactComponent as PageIcon } from "../../images/Dashboard/PageIcon.svg";
import DoughnutChart from "../../Components/Dashboard/Chart/DoughnutChart";
import { useDispatch, useSelector } from "react-redux";
import { getNumbers } from "../../REDUX/actions/stats";
import Loading from "../../Components/Common/Loading";
import { ProjectName } from "../../Api/EndPoints";

const DashboardView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNumbers()); // eslint-disable-next-line
  }, []);

  const { dbStats, statsLoading } = useSelector((state) => state.statsReducer);

  return statsLoading || !dbStats ? (
    <Loading />
  ) : (
    <div className="d-flex align-items-center pt100">
      <div className="d-flex flex-wrap justify-content-center gap24 w-100 pLeftRight200 ">
        <div className="w-35 hoverEffect">
          <ConsulteCard
            Title="Nombre d’articles actuels"
            Count={dbStats.articleNumber}
            Icon={ArticleIcon}
            FooterText="Consulter les articles"
            LinkTo="/blog"
            ColorCard="#C0392B"
          />
        </div>
        <div className="w-35 hoverEffect">
          <ConsulteCard
            Title="Nombre de fichiers "
            Count={dbStats.filesNumber}
            Icon={FileIcon}
            FooterText="Consulter les fichiers"
            LinkTo="/files"
            ColorCard="#9B59B6"
          />
        </div>
        {dbStats.productsNumber > 0 && (
          <div className="w-35 hoverEffect">
            <ConsulteCard
              Title="Nombre de produits"
              Count={dbStats.productsNumber}
              Icon={ProductIcon}
              FooterText="Consulter les produits"
              LinkTo="/products"
              ColorCard="#1ABC9C"
            />
          </div>
        )}
        <div className="w-35 hoverEffect">
          <ConsulteCard
            Title="Nombre de pages actuelles"
            Count={dbStats.pagesNumber}
            Icon={PageIcon}
            FooterText="Consulter les pages"
            LinkTo="/pages"
            ColorCard="#2980B9"
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardView;
